// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingView_container__Ao7da"};